import React, { useState } from "react";
import { Flex, Result, Table } from "antd";
import DeletedActionButton from "../DeletedActionButton/DeletedActionButton";
import Icon, { HistoryOutlined } from "@ant-design/icons";
import { DeleteComponent } from "../../../pages/admin/workspace/components/DeleteComponent";
import { FetchStatusEnum } from "../../../utils/enums";
// import { DeleteIcon } from "../../assets/icons/DeleteIcon";
import { DeleteIcon } from "../../../assets/icons/DeleteIcon";

import "./DataTable.scss";

const DataTable = ({
   rowKey,
   dataSource,
   columns,
   status,
   refetch,
   entityType,
   pagination,
   handleRestore,
   handleDelete
}) => {
   const loading = status === FetchStatusEnum.Loading;
   const isError = status === FetchStatusEnum.Error;

   const columnsWithActions = [
      ...columns,
      ...(!columns.find((column) => column.key === "actions")
         ? [
              {
                 key: "actions",
                 fixed: "right",
                 width: 100,
                 render: (_, entity) => (
                    <Actions
                       key={entity.id ?? entity[rowKey]}
                       refetch={refetch}
                       entity={entity}
                       entityType={entityType}
                       handleRestore={handleRestore}
                       handleDelete={handleDelete}
                    />
                 )
              }
           ]
         : [])
   ];
   return isError ? (
      <Result
         status="error"
         title="Error"
         subTitle="Something went wrong! Please try again later."
      />
   ) : (
      <Table
         prefixCls="deleted-data-table"
         rowKey={rowKey ?? "id"}
         style={{ overflowX: "auto" }}
         scroll={dataSource?.length ? { x: "max-content" } : {}}
         dataSource={dataSource}
         columns={columnsWithActions}
         loading={loading}
         pagination={pagination}
      />
   );
};

export default DataTable;

function Actions({ entity, handleDelete, handleRestore }) {
   const [deleteModal, setDeleteModal] = useState("");

   return (
      <div>
         <Flex gap={6}>
            <DeletedActionButton onClick={() => handleRestore(entity)}>
               <HistoryOutlined style={{ fontSize: 20, color: "#252938" }} />
            </DeletedActionButton>
            <DeletedActionButton onClick={() => setDeleteModal(entity.id)}>
               <DeleteIcon color="#252938" width="20" height="20" />
            </DeletedActionButton>
         </Flex>
         {deleteModal !== "" && (
            <DeleteComponent
               open={deleteModal.length > 0}
               setOpen={() => setDeleteModal("")}
               handleDelete={() => handleDelete(entity)}
               id={deleteModal}
            />
         )}
      </div>
   );
}
